import React, { useState, useEffect } from "react";
import FondoEquipos from "../images/Fondos/FondoEquipos.jpg";
import FondoEquipos1 from "../images/Fondos/Equipos/Equipos1.jpg";
import FondoEquipos2 from "../images/Fondos/Equipos/Equipos2.jpg";
import FondoEquipos3 from "../images/Fondos/Equipos/Equipos3.jpg";
import FondoEquipos4 from "../images/Fondos/Equipos/Equipos4.jpg";
import FondoEquipos5 from "../images/Fondos/Equipos/Equipos5.jpg";
import FondoEquipos6 from "../images/Fondos/Equipos/Equipos6.jpg";
import FondoEquipos7 from "../images/Fondos/Equipos/Equipos7.jpg";


const backgroundImages = [
  FondoEquipos,
  FondoEquipos1,
  FondoEquipos2,
  FondoEquipos3,
  FondoEquipos4,
  FondoEquipos5,
  FondoEquipos6,
  FondoEquipos7
];

const EquiposSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="equipos"
      className="relative w-full py-12 md:py-24 lg:py-32 text-white overflow-hidden"
    >
      {/* Fondo con imagen y gradiente */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 w-full h-full transition-opacity duration-1000">
          {backgroundImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Fondo Equipos ${index}`}
              className="absolute object-cover w-full h-full transition-opacity duration-1000"
              style={{
                opacity: currentImageIndex === index ? 1 : 0,
                zIndex: currentImageIndex === index ? 1 : 0
              }}
            />
          ))}
        </div>
        <div 
          className="absolute inset-0 z-10"
          style={{
            background: `
              linear-gradient(90deg, rgba(20, 24, 54, 0.95) 0%, rgba(20, 24, 54, 0.2) 47%, rgba(20, 24, 54, 0) 49.8%, rgba(20, 24, 54, 0) 50.2%, rgba(20, 24, 54, 0.2) 53%, rgba(20, 24, 54, 0.95) 100%),
              linear-gradient(180deg, rgba(20, 24, 54, 0.95) 0%, rgba(20, 24, 54, 0.2) 20%, rgba(20, 24, 54, 0) 35%, rgba(20, 24, 54, 0) 65%, rgba(20, 24, 54, 0.2) 80%, rgba(20, 24, 54, 0.95) 100%)
            `
          }}
        />
      </div>

      {/* Versión Escritorio - Se oculta en móvil */}
      <div className="hidden md:block container relative z-10 mx-auto px-4 md:px-6">
        <h2 className="text-2xl font-bold mb-16 text-center">
          DENTRO DE LAS UNIDADES DISPONEMOS DE:
        </h2>
        
        <div className="grid grid-cols-3 gap-8">
          {/* Columna izquierda */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold">• CHASIS Y ACOPLADO</h3>
            <h3 className="text-xl font-bold">• TOLVA</h3>
            <h3 className="text-xl font-bold">• ESCALABLES</h3>
            <h3 className="text-xl font-bold">• SEMIRREMOLQUE</h3>
            <h3 className="text-xl font-bold">• JAULAS</h3>
          </div>

          {/* Columna central - vacía para espacio */}
          <div></div>

          {/* Columna derecha */}
          <div className="space-y-4 text-right">
            <h3 className="text-xl font-bold">BATEAS •</h3>
            <h3 className="text-xl font-bold">SIDER •</h3>
            <h3 className="text-xl font-bold">TÉRMICOS •</h3>
            <h3 className="text-xl font-bold">TANQUES •</h3>
          </div>
        </div>
      </div>

      {/* Versión Móvil - Se oculta en escritorio */}
      <div className="md:hidden container relative z-10 mx-auto px-4">
        <h2 className="text-xl font-bold mb-8 text-center">
          DENTRO DE LAS UNIDADES DISPONEMOS DE:
        </h2>
        
        <div className="space-y-4">
          <div className="grid grid-cols-1 gap-3 text-center">
            <h3 className="text-lg font-bold">• CHASIS Y ACOPLADO</h3>
            <h3 className="text-lg font-bold">• TOLVA</h3>
            <h3 className="text-lg font-bold">• ESCALABLES</h3>
            <h3 className="text-lg font-bold">• SEMIRREMOLQUE</h3>
            <h3 className="text-lg font-bold">• BATEAS</h3>
            <h3 className="text-lg font-bold">• SIDER</h3>
            <h3 className="text-lg font-bold">• TÉRMICOS</h3>
            <h3 className="text-lg font-bold">• TANQUES</h3>
            <h3 className="text-lg font-bold">• JAULAS</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EquiposSection; 